module.exports = __webpack_public_path__ + "52ab65ef57edd4ce0d7e412745aad762.svg";